import { FC, JSX } from "react";
import { IGetCurrentUserResponse } from "@/_store/currentUser/contracts";
import List, { ListItems } from "@/app/components/List";

interface ICompanyProps {
  companyData?: IGetCurrentUserResponse;
  isLoading?: boolean;
}

const Company: FC<ICompanyProps> = ({ companyData, isLoading }): JSX.Element => {
  const {
    inn,
    email,
    company_name,
    mobile_phone,
  } = companyData ?? {};

  const companyInfoItems: ListItems[] = [
    { label: "Наименование компании", value: company_name },
    { label: "ИНН компании:", value: inn },
    { label: "Электронная почта", value: email },
    { label: "Контактный телефон", value: mobile_phone },
  ];

  return (
    <List items={companyInfoItems} isLoading={isLoading} />
  );
};

export default Company;
